<script setup>
import { ref, defineProps, watch, onMounted } from "vue";
import { useAEMFetch } from "@/hooks/common/fetch/useFetch";
import { useCsrCmpState } from "@/hooks/common/useCsrCmpState";
import { debounce } from "lodash-es";
import { getJumpLink } from "@/utils/common.js"
import { parseParams } from "@/utils/common";
import { isPhonePortrait } from '@/hooks/common/useUtils';
import { useDispatchGAEvent } from '@/hooks/common/useDispatchGAEvent';

const props = defineProps({
  stateKey: {
    type: String,
    default: "",
  },
  config: { 
    type: Object,
    default: () => {
      return {};
    },
  },
  keyWords: {
    type: String,
    default: "",
  },
  isSearch: {
    type: Boolean,
    default: false,
  },
  moduleType: {
    type: String,
    default: "",
  }
});

// eslint-disable-next-line
const { state } = useCsrCmpState({
  stateKey: props.stateKey,
});
const { urlPrefix, resultsText } = state.conf;

const loading = ref(false);
const currentPage = ref(1);
const total = ref(0);
const resultList = ref([]);
const pageSize = ref(10);
const learnMoreAbled=ref(false);

// 防抖搜索
const handleSearch = debounce((val) => {
  getPageList({ search: val, pIdx: currentPage.value });
}, 500);
const getPageList = async (params = {}) => {
  if (loading.value) {
    return;
  }
  loading.value = true; 
  const { data } = await useAEMFetch(
    parseParams(`${urlPrefix}.${props.moduleType}.json`, params)
  )
    .get()
    .json();
  console.log("data: ", data.value);
  total.value = data.value.totalHits;
  if (isPhonePortrait()) {
    resultList.value.push(...data.value.hits);
    if (currentPage.value >= Math.ceil(total.value / pageSize.value)) {
      learnMoreAbled.value=false
    }else{
      learnMoreAbled.value=true
    }
  } else {
    resultList.value = data.value.hits;
  }

  loading.value = false;
};

const toTop = () => {
      document.documentElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',// 元素顶部与视口顶部对齐
      inline: 'nearest'
    });
};

const handleClick = (url) => {
    location.href = getJumpLink(url);
}

const fetchPageList = () => {
  getPageList({ search: props.keyWords, pIdx: currentPage.value });
}

const handleCurrentChange = (val) => {
  currentPage.value = val;
  fetchPageList();
  toTop();
}

const handlePrevPage = () => {
  currentPage.value -= 1;
  fetchPageList();
  toTop();
}

const handleNextPage = () => {
  currentPage.value += 1;
  fetchPageList();
  toTop();
}

const changePage = () => {
  currentPage.value += 1;
  fetchPageList();
}

onMounted(() => {
  currentPage.value = 1;
  resultList.value = [];
  if (props.keyWords) { 
    handleSearch(props.keyWords);
  }
})

watch(
  () => props.moduleType,
  (newVal, oldVal) => {
    if (newVal && newVal !== oldVal) {
      currentPage.value = 1;
      total.value = 0;
      resultList.value = [];
      learnMoreAbled.value=false;
      if (props.keyWords) {
        handleSearch(props.keyWords);
      }
    }
  }
);

watch(
  () => props.keyWords,
  (newVal, oldVal) => {
    if (newVal && newVal !== oldVal) {
      currentPage.value = 1;
      total.value = 0;
      resultList.value = [];
      learnMoreAbled.value=false;
      handleSearch(newVal);

      useDispatchGAEvent("__GA_CLICK_SEARCH_CLICK__", {
        search_term: newVal,
        current_url: window.location.href,
        position_inside_page: "search_result",
      });
    }
  }
);


</script>

<template>
    <div class="tsb-search-result-container" v-Mdloading="loading">
        <div class="tsb-search-result-content" id="tsb-search-result">
            <div class="tsb-search-result-num">
                <span class="tsb-search-result-txt-main">{{ total }}</span>
                {{ resultsText }}
            </div>
            <div class="tsb-search-result-item" :key="'answer-'+item.url" v-for="item in resultList" @click="() => handleClick(item.url)">
                <div class="tsb-search-result-item__title">{{ item.title }}</div>
                <div class="tsb-search-result-item__content" v-html="item.content"></div>
            </div>
            <div class="tsb-search-result-empty" v-if="total === 0">
                <i class="tsb-search-result-empty__img"></i>
                <div class="tsb-search-result-empty__txt">{{ config?.noResultText }}</div>
            </div>
        </div>
        <div class="tsb-search-result-learn-more mb-page-pagination" v-if="learnMoreAbled">
            <div class="tsws-btn tsws-btn--black tsws-btn--M" @click="changePage">{{ config?.viewBtnText }}</div>
        </div>
        <md-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          @prev-click="handlePrevPage"
          @next-click="handleNextPage"
          :page-size="pageSize"
          :pager-count="5"
          :hide-on-single-page="true"
        ></md-pagination>
    </div>
</template>